import tw from "twin.macro";
export const PrimaryButton = tw.button`w-full bg-primary-500 text-gray-100 font-bold mr-2 my-4 sm:my-2 rounded-full py-3 px-5 flex items-center justify-center sm:w-56 sm:leading-none focus:outline-none hover:bg-primary-900 transition duration-300`;
